import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios"; 
import FormValidator from "../../../inc/FormValidator";
import Api from "../../../inc/Api";
import Settings from "../../../inc/Settings";
import Button from "../../inc/Button";
import Collapse from "../../inc/Collapse"; 
import FieldsRenderer from "../../Purchase Orders Internal/Edit PO/FieldsRenderer";
import Helper from "../../../inc/Helper";
import { Form } from "react-bootstrap";
import { getPopupMessageBasedOnStatus } from "../../../inc/Validation";
import Popup from "../../Popup/Popup";
import CommonAPICalls from "../Common Integration Calls/CommonApiCalls";

let cancelTokenSource = axios.CancelToken.source();
const ApiDetailsFormsPopup = ({ setClosePopupViewModal, reloadParentGrid }) => { 
  const [appMaster, setAppMaster] = useState([]);
  const [popupFormData, setPopupFormData] = useState({});
 
  const [apiCallBtn, setApiCallBtn] = useState(false);

  useEffect(() => {  
    fetchDataForAppMaster();
  }, []);
 
  let popupFormValidator;

  const validationConfigure = () => {
    let popupFieldConfig = [ 
      { name: "title", displayName: "Title", types: ["Required"] },
      { name: "enum_details", displayName: "Enum details", types: ["Required"] },
      { name: "field", displayName: "Field", types: ["Required"] }, 
      { name: "table", displayName: "Table", types: ["Required"] }, 
      { name: "api", displayName: "Api", types: ["Required"] }, 
      { name: "type", displayName: "Type", types: ["Required"] },
      { name: "default_value", displayName: "Default value", types: ["Required"] },
      { name: "reference_api", displayName: "Reference api", types: ["Required"] },
    ];

    if (!popupFormValidator) {
      popupFormValidator = new FormValidator(popupFieldConfig);
    }
  };

  validationConfigure();

  const fetchDataForAppMaster = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemAppMasterResponse = await apiCalls.getSystemApiDetails();
      if (systemAppMasterResponse) {
        setAppMaster(systemAppMasterResponse);
      };
    } catch (error) { 
      setAppMaster([]); 
    }
  }
 
  const fieldsArrayGeneral = [
    {
      className: "col-lg-4",
      label: "Title",
      inputType: "text",
      id: "title",
      required: true,
      name: "title",
    },
    {
      className: "col-lg-4",
      label: "Enum details",
      inputType: "text",
      id: "enum_details",
      required: true,
      name: "enum_details",
    },
    {
      className: "col-lg-4",
      label: "Field",
      inputType: "text",
      id: "field",
      required: true,
      name: "field",
    }, 
    {
      className: "col-lg-4",
      label: "Table",
      inputType: "text",
      id: "table",
      required: true,
      name: "table",
    }, 
    {
      className: "col-lg-4",
      label: "Api",
      inputType: "dropdown", 
      options: appMaster, 
      id: "api",
      required: true,
      name: "api",
    }, 
    {
      className: "col-lg-4",
      label: "Type",
      inputType: "text",
      id: "type",
      required: true,
      name: "type",
    },
    {
      className: "col-lg-4",
      label: "Default value",
      inputType: "text",
      id: "default_value",
      required: true,
      name: "default_value",
    },
    {
      className: "col-lg-4",
      label: "Reference api",
      inputType: "dropdown", 
      options: appMaster, 
      id: "reference_api",
      required: true,
      name: "reference_api",
    },
  ];

  const onClosePopupClick = () => {
    $("html").removeClass("rs_popup_open");
    setClosePopupViewModal(false);
  };

  const executePOSTPopupDocumentAPI = async () => {
    try { 
      let api = Api;
      api.setUserToken();

      const res = await api
        .axios()
        .post(
          Settings.apiAppUrl + "/lynkaz-api/",
          popupFormData,
          { cancelToken: cancelTokenSource.token }
        );

      if (res?.data?.success) {
        Helper.alert(res?.data?.message || 'Lynkaz api details created successfully'); 
        reloadParentGrid();
        onClosePopupClick(); 
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    } catch (error) { 
      getPopupMessageBasedOnStatus(error);
    }
  };

  const handleSubmit = () => {
    if (!popupFormValidator.isValid({ ...popupFormData })) {
      popupFormValidator.displayMessage();
      popupFormValidator.reset();
      return;
    }

    Helper.createDebouncedAPIFunction(
      [executePOSTPopupDocumentAPI],
      setApiCallBtn,
      cancelTokenSource
    )();
  };
  return (
    <Popup
      autoOpen={true}
      width="900px"
      onClose={onClosePopupClick}
    > 
      <>
        <h5 className="create_rfq_modal__title">Create Lynkaz Api Details</h5>

        <Collapse
          className="mt-4 mb-4"
          open={true}
          title={"General Information"}
        >
          <Form>
            <div className="container-fluid">
              <FieldsRenderer
                updateState={setPopupFormData}
                currentState={popupFormData}
                fieldsArray={fieldsArrayGeneral}
              />
            </div>
          </Form>
        </Collapse>
      </> 

      <div
        className="addDocumentNumber-body-buttons"
        style={{ justifyContent: "flex-end" }}
      >
        <Button
          isActive={false}
          title={"Cancel"}
          onClick={onClosePopupClick}
        />
        <Button
          isDisable={apiCallBtn}
          className="solid_btn"
          isActive={true}
          title={<div><span> {"Create"} </span> {apiCallBtn ? <output className="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output> : ''}</div>}
          onClick={handleSubmit}
        />
      </div>
    </Popup>
  );
};

export default ApiDetailsFormsPopup;